import { t } from '@lingui/macro';

export const FIELD_ERROR_MESSAGE_TO_TRANSLATION_MAP = (): Record<string, string> =>
  ({
    Required: t`Required`,
    'CUSTOM ERROR': t`Translated custom error `,
    'Invalid email': t`Invalid email`,
    'Please enter a valid email': t`Please enter a valid email`,
    'Consent is required': t`Consent is required to receive marketing emails from Rover.com and its affiliates.`,
    'A profile photo is required to continue.': t`A profile photo is required to continue.`,
    'You must have experience caring for pets to offer pet care through Rover.': t`You must have experience caring for pets to offer pet care through Rover.`,
    'Enter a whole number.': t`Enter a whole number.`,
    'Please write at least 25 words.': t`Please write at least 25 words.`,
    'Please enter no more than 35 characters.': t`Please enter no more than 35 characters.`,
    'Number must be less than or equal to 100': t`Number must be less than or equal to 100`,
    'Incorrect code': t`This code is incorrect. Check your email and try again`,
    'Alpha numeric error': t`This code is incorrect. The code is case sensitive and must only contain alphanumeric characters (A–Z and 0–9). Check your email and try again.`,
    'This field is required': t`This field is required`,
    'This field is required.': t`This field is required.`,
    'Please choose a day care type': t`Please choose a day care type`,
    'Please choose a boarding option': t`Please choose a boarding option`,
    'Enter your full name to sign the agreement.': t`Enter your full name to sign the agreement.`,
    'Please select a reason': t`Please select a reason`,
  } as const);
